import {listener, onReady, onResize, onScroll} from "../functions";

const position = 400;
const btnId = 'btn-scroll-to-top';

function init () {
	let $layoutScrollToTop = document.getElementById(btnId);

	if (!$layoutScrollToTop) {
		let div = document.createElement('div');
		div.classList.add('to-top');
		div.setAttribute('id', btnId);
		div.innerHTML = '<span><i class="fal fa-chevron-up"></i></span>';

		document.body.append(div);
	}

	setPosition();
}

function setPosition () {
	let $sticky = document.getElementById(btnId);

	if (document.documentElement.scrollTop >= position) {
		$sticky.classList.add('is-active')
	} else {
		$sticky.classList.remove('is-active')
	}
}

listener('click', '#' + btnId, function () {
	window.scrollTo({top: 0, behavior: 'smooth'});
});

onScroll(setPosition);
onReady(init);
onResize(init);